<template>
	<a-row type="flex" :gutter="16">
		<a-col :span="24">
			<media-analyze v-if="!loading" :analisis="analisis" :post="post" />
		</a-col>
	</a-row>
</template>

<script>
import MediaAnalyze from '@/components/widgets/Post/Analysis/Image'

import { mapActions } from 'vuex'
import * as ACTIONS from '@/store/actions'

export default {
	name: 'PostMedia',
	components: {
		MediaAnalyze,
	},
	props: {
		post: {
			type: Object,
			required: true,
		},
	},
	data: function() {
		return {
			type: 'face',
			border: 2,
			color: '#DDE6E8',
			loading: true,
			analisis: {},
		}
	},
	created() {
		this.imageAnalysis(this.post.id).then(res => {
			this.loading = false
			this.analisis = res
		})
	},
	methods: {
		...mapActions({
			imageAnalysis: ACTIONS.ANALYSIS.IMAGE,
		}),
	},
}
</script>

<style lang="scss">
@import './media.module.scss';
</style>
